import { FeaturePermission } from '@interfaces/featurePermission';
import { fetcher } from '@utils/fetcher';

const API_URL = '/api/featurePermission';

export const findFeaturePermissions = async (): Promise<FeaturePermission[]> =>
  fetcher(API_URL, { method: 'POST' });
